import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "all-price-detail-content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "tip" }
const _hoisted_4 = { class: "price-item" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "fee-detail-price" }
const _hoisted_8 = { class: "jpy" }
const _hoisted_9 = { class: "cny" }
const _hoisted_10 = {
  key: 0,
  class: "fee-detail"
}
const _hoisted_11 = { class: "fee-detail-title" }
const _hoisted_12 = { class: "fee-detail-price" }
const _hoisted_13 = { class: "jpy" }
const _hoisted_14 = { class: "cny" }
const _hoisted_15 = { class: "total-price-content" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "jpy" }
const _hoisted_18 = { class: "cny" }

import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'
import { t } from '@/plugins/i18n'
import { computed, ref, watch } from 'vue'
import { getPriceTypeInfo } from '@/views/shopcart/useChoice'

export default /*#__PURE__*/_defineComponent({
  props: ['detail', 'priceType', 'season', 'transportType'],
  setup(__props) {

const props = __props

const loading = ref(false)
const activeObj: any = ref({
  goodsActive: false,
  additionActive: false,
  feeActive: false
})
const data: any = ref([])
watch(() => props.detail, async () => {
  const priceType = (await getPriceTypeInfo(props.season))?.name2
  const { price, productPriceExchange, innerShipSinglePrice, innerShipPriceExchange, productAdditionPriceResult, allIncludeTaxPrice, allIncludeTaxPriceExchange, internalShipResult, allIncludeShipPrice, allIncludeShipPriceExchange, defaultAdditionPrice, defaultAdditionPriceExchange, defaultAdditionPriceResult, productAdditionPrice, productAdditionPriceExchange } = props.detail
  data.value = [
    {
      name: t('商品金额'),
      key: 'goodsActive',
      jpy: innerShipPriceExchange + productPriceExchange,
      cny: price + innerShipSinglePrice,
      list: [
        {
          name: t('国内运费'),
          jpy: innerShipPriceExchange,
          cny: innerShipSinglePrice
        },
        {
          name: t('商品代金'),
          jpy: productPriceExchange,
          cny: price
        }
      ]
    },
    {
      name: t('商品附加项'),
      key: 'additionActive',
      jpy: productAdditionPriceExchange,
      cny: productAdditionPrice,
      list: productAdditionPriceResult?.additionPriceResult?.map((v) => ({
        name: v.additionName,
        jpy: Math.ceil(v.price * productAdditionPriceResult.exchangeRate),
        cny: v.price
      }))
    },
    {
      name: t('手续费'),
      key: 'feeActive',
      jpy: defaultAdditionPriceExchange,
      cny: defaultAdditionPrice,
      list: defaultAdditionPriceResult?.additionPriceResult?.map((v: any) => ({
        name: v?.additionName,
        jpy: Math.ceil(defaultAdditionPriceResult?.exchangeRate * v.price),
        cny: v.price
      }))
    },
    {
      name: t('国际运费') + priceType + `(${props.transportType === 1 ? t('海运') : t('空运')})`,
      jpy: allIncludeShipPriceExchange,
      cny: allIncludeShipPrice
    },
    {
      name: t('关税1'),
      jpy: allIncludeTaxPriceExchange,
      cny: allIncludeTaxPrice
    }
    // {
    //   name: t('後払い手数料'),
    //   jpy: 200,
    //   cny: 10
    // }
  ]
}, {
  immediate: true
})
const open = (item: any) => {
  if (!item.key) return
  activeObj.value[item.key] = !activeObj.value[item.key]
}
const change = () => {

}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (__props.detail?.allIncludeType === 1)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "all-ptice-detail-com",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
      }, [
        _createVNode(_component_el_dropdown, {
          trigger: "click",
          "popper-class": "pop-all-ptice-detail",
          onVisibleChange: change
        }, {
          dropdown: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('オールイン単価（税込）')), 1),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('该商品一价全包，单价固定，最终以实际上架数量进行收费，多退少补，请及时关注资金变化。')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["price-item-title", { 'cursor-pt': item.key }]),
                      onClick: ($event: any) => (open(item))
                    }, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1),
                      (item.key)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (activeObj.value[item.key])
                              ? (_openBlock(), _createBlock(_component_el_icon, {
                                  key: 0,
                                  class: "icon"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ArrowUp))
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_el_icon, {
                                  key: 1,
                                  class: "icon"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ArrowDown))
                                  ]),
                                  _: 1
                                }))
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_5),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, "JPY" + _toDisplayString(item.jpy), 1),
                      _createElementVNode("span", _hoisted_9, "CNY" + _toDisplayString(item.cny.toFixed(2)), 1)
                    ])
                  ]),
                  (item.list?.length && activeObj.value[item.key!])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (temp, key) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "fee-detail-item",
                            key: key
                          }, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(temp.name), 1),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("span", _hoisted_13, "JPY" + _toDisplayString(temp.jpy), 1),
                              _createElementVNode("span", _hoisted_14, "CNY" + _toDisplayString(temp.cny.toFixed(2)), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('オールイン単価（税込）')) + ":", 1),
                _createElementVNode("span", _hoisted_17, "JPY" + _toDisplayString(__props.detail.allIncludeProductPriceExchange), 1),
                _createElementVNode("span", _hoisted_18, "CNY" + _toDisplayString(__props.detail.allIncludeProductPrice), 1)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "el-dropdown-link",
              type: "text",
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('明细')) + "> ", 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})